import * as React from 'react';
import { MaskedInput } from '@cian/ui-kit';
import { useCallback, useEffect, useRef } from 'react';

export interface IPhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
}

export function PhoneInput(props: IPhoneInputProps) {
  const { onChange } = props;

  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputRef.current && inputRef.current.type !== 'tel') {
      inputRef.current.type = 'tel';
      inputRef.current.autocomplete = 'tel';
    }
  }, [inputRef]);

  const wrappedOnChange = useCallback(
    (value: string) => {
      onChange(value ? '+7' + value : '');
    },
    [onChange],
  );

  const preprocessInputChars = useCallback((inputChar: string, maskedValue: string) => {
    if (inputChar === '8' && maskedValue === '') {
      return '';
    }

    return inputChar;
  }, []);

  return (
    <MaskedInput
      lazy
      inputRef={inputRef}
      value={props.value.replace(/^\+7/, '')}
      onChange={wrappedOnChange}
      preprocessInputChars={preprocessInputChars}
      mask="+7 000 000-00-00"
      placeholder="+7"
      size="M"
      invalid={props.invalid}
    />
  );
}
